import ReservationAPI from 'api/reservation';
import {CARD_DECLINE} from 'common/payment-picker';

export const FETCH_RESERVATION = 'FETCH_RESERVATION';
export const REFETCH_RESERVATION = 'REFETCH_RESERVATION';
export const REFUND_RESERVATION = 'REFUND_RESERVATION';
export const UPDATE_VEHICLE = 'UPDATE_VEHICLE';
export const UPDATE_RESERVATION_TIMES = 'UPDATE_RESERVATION_TIMES';
export const UPDATE_PHONE = 'UPDATE_PHONE';
export const PARKING_PASS_SET_ERROR = 'PARKING_PASS_SET_ERROR';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const fetchReservation = ({reservationId, accessKey}) => {
    return dispatch => {
        dispatch({
            type: FETCH_RESERVATION,
            payload: ReservationAPI.getById({reservationId, accessKey}),
        }).catch(() => {}); // eslint-disable-line no-empty-function
    };
};

// fetch reservation in the background
export const refetchReservation = ({reservationId, accessKey}) => {
    return dispatch => {
        dispatch({
            type: REFETCH_RESERVATION,
            payload: ReservationAPI.getById({reservationId, accessKey}),
        }).catch(() => {}); // eslint-disable-line no-empty-function
    };
};

export const refundReservation = ({reason, refundAsCredit = false}) => {
    return (dispatch, getState) => {
        const {parkingPass} = getState();
        const {data: reservation, accessKey} = parkingPass;

        return dispatch({
            type: REFUND_RESERVATION,
            payload: ReservationAPI.refund({
                reservationId: reservation.rentalId,
                accessKey,
                reason,
                refundAsCredit,
            }).then(response => {
                if (response?.totalRefunded) {
                    return {
                        paymentStatus: 'refund',
                        canUpdateStartsAndEnds: false,
                    };
                }
            }),
        })
            .then(() => {
                dispatch(
                    refetchReservation({
                        reservationId: reservation.rentalId,
                        accessKey,
                    })
                );

                return {success: true};
            })
            .catch(() => {
                return {success: false};
            });
    };
};

export const setError = ({error}) => ({
    type: PARKING_PASS_SET_ERROR,
    payload: error,
});

export const toggleModal = ({modal}) => ({
    type: TOGGLE_MODAL,
    payload: modal,
});

export const updateVehicle = ({
    reservationId,
    price,
    vehicleProfileId = null,
    cardExternalId = null,
    stripeToken = null,
    refundAsCredit = false,
    guestVehicle = null,
    accessKey = null,
}) => {
    return dispatch => {
        return dispatch({
            type: UPDATE_VEHICLE,
            payload: ReservationAPI.updateVehicle({
                reservationId,
                vehicleProfileId,
                price,
                cardExternalId,
                stripeToken,
                refundAsCredit,
                guestVehicle,
                accessKey,
            }),
        })
            .then(() => {
                return {success: true};
            })
            .catch(error => {
                return {
                    success: false,
                    // A bit of a brittle approach, but our error architecture built around redux-promise-middleware makes getting at the original error code difficult
                    error:
                        error.message.includes('your card') ||
                        error.message.includes('declined')
                            ? CARD_DECLINE
                            : '',
                };
            });
    };
};

export const updateReservationTimes = ({
    reservationId,
    rateDiff,
    timezone,
    cardExternalId = null,
    stripeToken = null,
    refundAsCredit = false,
}) => {
    return (dispatch, getState) => {
        const {parkingPass, user} = getState();
        const {accessKey} = parkingPass;
        const {
            data: {status},
        } = user;

        return dispatch({
            type: UPDATE_RESERVATION_TIMES,
            payload: ReservationAPI.updateReservationTimes({
                reservationId,
                rateDiff,
                timezone,
                cardExternalId,
                stripeToken,
                refundAsCredit,
                accessKey,
                userStatus: status,
            }),
        })
            .then(() => {
                dispatch(
                    refetchReservation({
                        reservationId,
                        accessKey,
                    })
                );

                return {success: true};
            })
            .catch(error => {
                return {
                    success: false,
                    // A bit of a brittle approach, but our error architecture built around redux-promise-middleware makes getting at the original error code difficult
                    error:
                        error.message.includes('your card') ||
                        error.message.includes('declined')
                            ? CARD_DECLINE
                            : error.message,
                };
            });
    };
};

export const updatePhone = ({phoneNumber}) => {
    return (dispatch, getState) => {
        const {
            parkingPass: {data: reservation, accessKey},
        } = getState();

        return dispatch({
            type: UPDATE_PHONE,
            payload: ReservationAPI.updatePhone({
                reservationId: reservation.rentalId,
                phoneNumber,
                accessKey,
            }),
        })
            .then(() => {
                return {success: true};
            })
            .catch(() => {
                return {success: false};
            });
    };
};
